import React from 'react';
import { i18n } from 'config/locales';
import ValidationElement from 'components/Form/ValidationElement';
import RadioGroup from 'components/Form/RadioGroup';
import Radio from 'components/Form/Radio';
import { ValidationElementProps } from '../../../Form/ValidationElement/ValidationElement';
import { CommonOnUpdate, CommonOnError, CommonRequired } from '../../../../types/props';
import { ErrorCode } from '../../../../redux/modules/application/reducers/error';
import { FinancialTaxesItemModel } from '../../../../forms/sections/financial/taxes/types';

interface Props extends Partial<FinancialTaxesItemModel['Failure']>, ValidationElementProps {
  onUpdate?: CommonOnUpdate
  onError?: CommonOnError
  required?: CommonRequired

  attribute?: string
  name?: string
  className?: string
}

export default class FailureType extends ValidationElement<Props> {
  update = (values: Partial<FinancialTaxesItemModel['Failure']>) => {
    if (this.props.onUpdate) {
      this.props.onUpdate({
        name: this.props.name,
        value: values.value,
      });
    }
  };

  render() {
    return (
      <RadioGroup
        className={`option-list ${this.props.className || ''}`.trim()}
        required={this.props.required}
        onError={this.props.onError}
        selectedValue={this.props.value}
        attribute={this.props.attribute}
      >
        <Radio
          label={i18n.t('financial.taxes.label.file')}
          value="File"
          className="failure-file"
          onUpdate={this.update}
          onError={this.props.onError}
        />
        <Radio
          label={i18n.t('financial.taxes.label.pay')}
          value="Pay"
          className="failure-pay"
          onUpdate={this.update}
          onError={this.props.onError}
        />
        <Radio
          label={i18n.t('financial.taxes.label.both')}
          value="Both"
          className="failure-both"
          onUpdate={this.update}
          onError={this.props.onError}
        />
      </RadioGroup>
    );
  }
}

FailureType.defaultProps = {
  value: '',
  onError: (value, arr: ErrorCode) => arr,
};
